var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fluid fill-height justify-center text-xs-center",attrs:{"id":"forbiddenPage"}},[_c('h1',{staticClass:"valign white--text"},[_vm._v("(._.)?")]),_c('h2',{staticClass:"valign white--text display-3"},[_vm._v("Forbidden")])])
}]

export { render, staticRenderFns }